module.exports = __webpack_public_path__ + "static/img/textiles.fc2c2b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/textiles.jpg
// module id = pyg4
// module chunks = 1